import { ReactElement } from 'react'
import { Modal, Input } from '../../../../components'
import strings from '../../../../locale/en'
import { ApproveProps } from './typings'
import { InputWrapper } from './subcomponents'

const Approve = ({
  handleCancel,
  handleSubmit
}: ApproveProps): ReactElement => {
  const {
    pendingRequests: {
      approve: { title, description }
    }
  } = strings

  return (
    <Modal
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      title={title}
      description={description}
    >
      <InputWrapper>
        <Input
          width="80%"
          isRequired
          placeholder={'branchName'}
          value={'180'}
          name="branchName"
          onBlur={() => {}}
          error={''}
          onChange={(value: string) => console.log(value)}
        />
      </InputWrapper>
    </Modal>
  )
}

export default Approve
